import { onCleanup, onMount } from "solid-js";

export function usePreventVirtualKeyboardBodyScroll() {
  onMount(() => {
    // 锁定 body 滚动位置
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
  });

  onCleanup(() => {
    // 恢复 body 滚动
    const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollY);
  });
}
